import React from 'react';
import { useReceptionLocale } from '../reception/locale';
import { useDepartmentLocale } from '../ui/locale/departmentLocale';

interface OfflineStatusBannerProps {
  authenticated?: boolean;
}

const OfflineStatusBanner: React.FC<OfflineStatusBannerProps> = () => {
  const fallback = useReceptionLocale();
  const locale = useDepartmentLocale();
  const t = locale?.t ?? fallback.t;
  const [online, setOnline] = React.useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  React.useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);

    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        padding: '10px 14px',
        textAlign: 'center',
        background: '#9f1239',
        color: '#fff',
        fontSize: '0.95rem',
        fontWeight: 600,
      }}
      role="status"
      aria-live="polite"
    >
      {locale ? t('You are offline. Check your connection.') : fallback.t(typeof window !== 'undefined' && localStorage.getItem('app_language') === 'ar' ? 'الإنترنت مقطوع. اتأكد من الاتصال.' : 'You are offline.')}
    </div>
  );
};

export default OfflineStatusBanner;
